import styled from 'styled-components';

import { heightQueries, mediaQueries } from '@ui-component-library/styles/breakpoints';
import { MODAL_RESET } from '@ui-component-library/styles/components.reset';
import { SPACING } from '@ui-component-library/styles/spacing';

import { NEUTRAL_COLORS } from '../styles/colors';

export const S = {
  Backdrop: styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(42, 46, 51, 0.5); // charcoal-500 with 50% opacity
    z-index: 1050;
    display: flex;
    justify-content: center;
    align-items: center;
  `,

  Wrapper: styled.div<{ $borderLess?: boolean }>`
    ${MODAL_RESET}

    z-index: 1050;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    height: 780px;
    flex-direction: column;
    background-color: #faf9f8; /* FIXME: CHECK COLORS WITH JOAKIM */
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    margin: auto;
    border: ${(props) =>
      props.$borderLess ? 'none' : `1px solid ${NEUTRAL_COLORS['charcoal-alpha-50']}`};
    overflow: hidden;
    box-shadow: 0px 4px 24px ${NEUTRAL_COLORS['charcoal-alpha-475']};

    ${heightQueries.maxHeight(780)} {
      height: 95%;
    }

    ${mediaQueries.mobile} {
      width: 100%;
      height: 95%;
    }

    ${mediaQueries.tablet} {
      top: 0;
      width: 720px;
      border-bottom-left-radius: 16px;
      border-bottom-right-radius: 16px;
    }

    ${mediaQueries.desktop} {
      top: 0;
      width: 720px;
      border-bottom-left-radius: 16px;
      border-bottom-right-radius: 16px;
    }
  `,

  Header: styled.div<{ $justifyContent?: 'space-between' | 'end' }>`
    padding: ${SPACING.size12} ${SPACING.size16};
    display: flex;
    flex-direction: row;
    justify-content: ${(props) => props.$justifyContent || 'space-between'};
    align-items: center;
    border-bottom: 1px solid ${NEUTRAL_COLORS['charcoal-alpha-50']};
    flex: 0 0 auto;
  `,

  Content: styled.div<{ $bgColor?: string }>`
    background-color: ${({ $bgColor }) =>
      NEUTRAL_COLORS[`${$bgColor || 'white-50'}` as keyof typeof NEUTRAL_COLORS]};
    display: flex;
    padding: ${SPACING.size20} ${SPACING.size16} ${SPACING.size32} ${SPACING.size16};
    flex: 1 1 auto;
    overflow-y: auto;
    max-width: 720px;
    padding-bottom: ${SPACING.size20};
  `,

  Footer: styled.div`
    border-top: 1px solid ${NEUTRAL_COLORS['charcoal-alpha-50']};
    background-color: ${NEUTRAL_COLORS['stone-50']};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    flex: 0 0 auto;
    padding: ${SPACING.size16};
    min-height: unset;
    gap: ${SPACING.size16};
  `
};
